// [codex 2026-05-23] Shared chat reasoning-level contract.
export type ReasoningLevel = "fast" | "standard" | "deep" | "extra-high";

export interface ReasoningLevelDef {
  id: ReasoningLevel;
  label: string;
  shortLabel: string;
  description: string;
  budget: string;
}

export const REASONING_LEVELS: ReasoningLevelDef[] = [
  {
    id: "fast",
    label: "Fast",
    shortLabel: "F",
    description: "Uses Sol at low intelligence for a quick, focused answer.",
    budget: "1-2 turns",
  },
  {
    id: "standard",
    label: "Standard",
    shortLabel: "S",
    description: "Balanced context and tool use.",
    budget: "3 turns",
  },
  {
    id: "deep",
    label: "Deep",
    shortLabel: "D",
    description: "Broader context and stronger verification.",
    budget: "5 turns",
  },
  {
    id: "extra-high",
    label: "Extra High",
    shortLabel: "EH",
    description: "Exhaustive inspection and proof for consequential work.",
    budget: "7 turns",
  },
];

export function normalizeReasoningLevel(value: unknown): ReasoningLevel {
  if (
    value === "fast" ||
    value === "standard" ||
    value === "deep" ||
    value === "extra-high"
  ) {
    return value;
  }
  return "standard";
}

export function shouldThinkHarder(level: ReasoningLevel): boolean {
  return level === "deep" || level === "extra-high";
}
